<template>
	<div :class="{inview: getInView}">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Observer',
	data() {
		return {
			observer: null,
			inView: false,
		};
	},
	props: {
		root: {
			type: [Object, HTMLElement],
			default: null,
		},
		rootMargin: {
			type: String,
			default: '0px',
		},
		threshold: {
			type: [Array, Number],
			default: 0,
		},
		onMounted: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		init() {
			this.setObserver();
			this.observe();
		},
		unobserve() {
			this.observer.unobserve(this.$el);
		},
		observe() {
			this.observer.observe(this.$el);
		},
		destroyMe() {
			if (this.observer) {
				this.unobserve();
				this.observer = null;
			}
		},
		handleIntersect(entry, inView) {
			this.inView = inView;
			this.$emit('onChange', entry, this.unobserve);
		},
		setObserver() {
			this.observer = new IntersectionObserver(
				(entries) => this.handleIntersect(entries[0], entries[0].isIntersecting),
				{
					root: this.root,
					rootMargin: this.rootMargin,
					threshold: this.threshold,
				},
			);
		},
	},
	computed: {
		getInView() {
			return this.inView;
		},
	},
	mounted() {
		if (this.onMounted) this.init();
	},
	beforeDestroy() {
		this.destroyMe();
	},
};
</script>
